const swiperSlider = () => {
  const sliders = document.querySelectorAll('.swiper');
  if (!sliders) return;

  sliders.forEach(slider => {
    let config = {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },
    }

    if (slider.classList.contains('post-gallery__slider')) {
      config.breakpoints = {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      }
    }

    new Swiper(slider, config)
  })
};

export default swiperSlider;
